module.exports = __webpack_public_path__ + "img/Ellipse 17.35492bf1.svg";